<div class="modal-header">
  <h5 class="modal-title">Manage Images</h5>
  <span class="fa fa-close" (click)="activeModal.close()"></span>
</div>

<div class="modal-body row no-gutters h-100">
  <div class="col-6 pr-3 ">
    <div class="d-flex flex-column">
      <!-- <ng-autocomplete style="width: 100%;" [data]="projects" searchKeyword="projectname" placeholder="Select Project"
        (selected)='selectEvent($event)' (inputChanged)='onChangeSearch($event)' (inputFocused)='onFocused($event)'
        [itemTemplate]="itemTemplate" [notFoundTemplate]="notFoundTemplate">
      </ng-autocomplete> -->

      <select (change)="selectEvent($event)" class="form-control">
        <option [value]="EMPTY_GUID">All</option>
        <option *ngFor="let project of projects" [value]="project.id" [selected]="project.id == selectedProject">
          {{project.projectname}}</option>
      </select>

      <ng-template #itemTemplate let-item>
        <a [innerHTML]="item.projectname"></a>
      </ng-template>
      <ng-template #notFoundTemplate let-notFound>
        <div [innerHTML]="notFound"></div>
      </ng-template>

      <div class="check mt-3 d-flex align-items-center">
        <span class="mr-2">Variant of JSN</span>
        <label class="switch m-0">
          <input type="checkbox" [(ngModel)]="isJsnIndividual" (change)="onToggleChange()" />
          <span class="slider round"></span>
        </label>
      </div>

      <div class="divider"></div>

      <div class="source-container">
        <ngb-accordion #acc="ngbAccordion" activeIds="panel-1" *ngFor="let jsnProject of jsnProjects">
          <ngb-panel id="panel-1">
            <ng-template ngbPanelHeader let-opened="opened">
              <button ngbPanelToggle class="w-100 btn btn-link p-0 d-flex align-items-center justify-content-between">
                <span class="section-title">{{jsnProject.jsn.project.projectname + '-' + jsnProject?.jsn?.name + ' ' +
                  (jsnProject?.jsn?.jsnother || '')}}</span>
                <div class="chevron" [ngClass]="{
                    'panel-collapsed': !opened,
                    'panel-expanded': opened
                  }"></div>
              </button>
            </ng-template>
            <ng-template ngbPanelContent>
              <ng-container *ngIf="jsnProject.urls && (jsnProject.urls | keyvalue).length > 0">
                <div class="row no-gutters">
                  <ng-container *ngFor="let image of jsnProject?.urls | keyvalue; let i = index ">
                    <ng-container *ngIf="i == 0;else smallImage">
                      <div class="col-12 image-col" draggable="true" (dragstart)="onDragStart($event,image)">
                        <div class="image-box main-image">
                          <img [src]="image.value" />
                        </div>
                      </div>
                    </ng-container>
                    <ng-template #smallImage>
                      <div class="col-4 image-col" draggable="true" (dragstart)="onDragStart($event,image)">
                        <div class="image-box">
                          <img [src]="image.value" />
                        </div>
                      </div>
                    </ng-template>
                  </ng-container>
                </div>
              </ng-container>
            </ng-template>
          </ngb-panel>
        </ngb-accordion>
      </div>
    </div>
  </div>

  <div class="col-6 bl pl-3">
    <div class="d-flex flex-column h-100">
      <p class="project-title">{{projectName}} - {{jsnName}} {{jsnOther}}</p>

      <div class="selected-container" style="flex: 1; overflow-y: auto;">
        <div class="row no-gutters">
          <ng-container *ngFor="let i of [1,2,3,4,5,6,7];">
            <ng-container *ngIf="i == 1 ; else smallImage">
              <div class="col-12 image-col">
                <div class="image-box main-image drop-zone" (drop)="onDrop($event,i)" (dragover)="onDragOver($event)"
                  [draggable]="images['image'+i]?.url ? true : false"
                  (dragstart)="images['image'+i]?.url && onSelectedImageDragStart($event, i)">
                  <ng-container *ngIf="images['image'+i]?.url; else uploadBox">
                    <img [src]="sanitizeImage(images['image'+i]?.url)" />
                    <button class="remove-btn" (click)="removeImage(i)"><span class="fa fa-close"></span></button>
                  </ng-container>
                  <ng-template #uploadBox>
                    <label class="upload-label">
                      <span class="fa fa-plus"></span>
                      <input type="file" accept="image/*" hidden (change)="onImageUpload($event, i)" />
                    </label>
                  </ng-template>
                </div>
              </div>
            </ng-container>
            <ng-template #smallImage>
              <div class="col-4 image-col">
                <div class="image-box drop-zone" (drop)="onDrop($event,i)" (dragover)="onDragOver($event)"
                  [draggable]="images['image'+i]?.url ? true : false"
                  (dragstart)="images['image'+i]?.url && onSelectedImageDragStart($event, i)">
                  <ng-container *ngIf="images['image'+i]?.url; else uploadBox">
                    <img [src]="sanitizeImage(images['image'+i]?.url)" />
                    <button class="remove-btn" (click)="removeImage(i)"><span class="fa fa-close"></span></button>
                  </ng-container>
                  <ng-template #uploadBox>
                    <label class="upload-label">
                      <span class="fa fa-plus"></span>
                      <input type="file" accept="image/*" hidden (change)="onImageUpload($event, i)" />
                    </label>
                  </ng-template>
                </div>
              </div>
            </ng-template>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-primary" (click)="activeModal.close()">Cancel</button>
  <button type="button" class="btn btn-primary" (click)="save()">Save</button>
</div>